/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import Question from '../components/Question'
import { withStyles } from '@material-ui/core/styles/index'
import QuestionPageFooter from './partials/QuestionPageFooter'
import AttentionElement from '../components/AttentionElement'
import { styles } from './Prelander.styles'
import QuestionPageHeader from './partials/QuestionPageHeader'
import QuestionPageStepper from './partials/QuestionPageStepper'
import PrelanderComplete from '../components/PrelanderComplete'
import { Box, Button, Grid, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HeaderImage from './partials/HeaderImage'
import Terms from './partials/Terms'
import queryString from 'query-string'
import { storePrelanderAnswer } from '../../api'
import parse from 'html-react-parser'
import PrelanderCompleteModern from "../components/PrelanderCompleteModern";

const completeAnimationStepLenghts = [4000, 4000, 5000, 2000, 2000, 5000]
const researchAnimationDuration = 12000 // Modern research animation duration
const parsedQueryString = queryString.parse(window.location.search)
const defaultAnswers = parsedQueryString['pa'] ? [parsedQueryString['pa']] : []
const showAnswerPercentages = !!parsedQueryString['prc']
const initAnswerValue = parsedQueryString['iav'] ?? null
const hasInitialAnswer = !!initAnswerValue

function getInitAnswerPercentagesQuestions() {
    if (!initAnswerValue) {
        return []
    }
    const questionArray = String(initAnswerValue).split('|')
    let title = null
    let options = []
    if (questionArray.length === 2) {
        title = questionArray[0]
        const optionArray = String(questionArray[1]).split(';')
        for (let optionsItem of optionArray) {
            const optionItemArray = String(optionsItem).split('_')
            if (optionItemArray.length !== 3) {
                continue
            }
            options.push({
                checked: String(optionItemArray[0]) === '1',
                label: optionItemArray[1],
                answerPercentage: Number(optionItemArray[2]),
                setWidth: true
            })
        }
    }
    if (!title || options.length === 0) {
        return []
    }

    return [
        {
            id: 'init',
            title: title,
            options: options
        }
    ]
}

class Prelander extends PureComponent {
    state = {
        questionPages: [],
        questionPageIndex: null,
        questionValues: [],
        showComplete: false,
        completeAnimationStep: 0,
        answers: defaultAnswers,
        answerPercentagesQuestions: getInitAnswerPercentagesQuestions(),
        isLoading: false,
        showNextButton: false
    }

    componentDidMount() {
        const questionPages = this.props.prelander.questionPages
        const questionPageIndex = questionPages[0] ? 0 : null
        if (questionPageIndex === null) {
            this.showComplete()
        }
        this.props.onAnswersChanged(defaultAnswers)
        this.setState({ questionPages: questionPages, questionPageIndex: questionPageIndex })
    }

    onQuestionValueChanged = (title, value, validate = true) => {
        this.onChangeCurrentAnswerPercentages(this.state.questionPageIndex, value)

        const nextQuestionPageIndex = this.state.questionPageIndex + 1
        const questionPageIndex = this.state.questionPages[nextQuestionPageIndex] ? nextQuestionPageIndex : null
        const newAnswers = [...this.state.answers, value]
        if (questionPageIndex === null) {
            if (!showAnswerPercentages) {
                this.setState({ questionPageIndex: null, answers: newAnswers, showComplete: true })
                this.showComplete()
            } else {
                this.setState({ showNextButton: true })
                setTimeout(() => {
                    this.scrollToElement('next-button')
                }, 100)
            }
        }

        this.props.onAnswersChanged(newAnswers)

        if (questionPageIndex) {
            this.setState({ questionPageIndex: questionPageIndex, answers: newAnswers })
            setTimeout(() => {
                this.scrollToElement('prelander-questions')
            }, 100)
        }

        storePrelanderAnswer(this.props.visitorSessionId, title, value)
    }

    onChangeCurrentAnswerPercentages = (questionPageIndex, answerValue) => {
        const questionPage = this.state.questionPages[questionPageIndex] ?? null
        if (!questionPage) {
            return
        }
        const question = questionPage.elements?.[0]
        if (!question) {
            return
        }
        const options = question.options
        for (let option of options) {
            option.checked = answerValue === option.value
            option.setWidth = false
        }
        question.options = options

        const prevAnswerPercentagesQuestions = this.state.answerPercentagesQuestions

        this.setState({ answerPercentagesQuestions: [...prevAnswerPercentagesQuestions, question] })

        setTimeout(() => {
            const widthOptions = question.options
            for (let option of widthOptions) {
                option.setWidth = true
            }
            question.options = options

            this.setState({ answerPercentagesQuestions: [...prevAnswerPercentagesQuestions, question] })
        }, 500)
    }

    scrollToElement = id => {
        const element = document.getElementById(id)
        if (!this.isElementInView(element)) {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
    }

    isElementInView = element => {
        const bounding = element.getBoundingClientRect()
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    showComplete = () => {
        this.setState({ showComplete: true })

        if (this.props.prelander.completeAnimation === 'long') {
            let waitTime = completeAnimationStepLenghts[0]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 1 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[1]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 2 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[2]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 3 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[3]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 4 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[4]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 5 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[5]
            setTimeout(() => {
                this.props.onComplete()
            }, waitTime)
        } else if (this.props.prelander.completeAnimation === 'research') {
            // Use modern animation duration
            setTimeout(() => {
                this.props.onComplete()
            }, researchAnimationDuration)
        } else {
            let waitTime = completeAnimationStepLenghts[0]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 1 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[1]
            setTimeout(() => {
                this.setState({ completeAnimationStep: 2 })
            }, waitTime)

            waitTime += completeAnimationStepLenghts[2]
            setTimeout(() => {
                this.props.onComplete()
            }, waitTime)
        }
    }

    render() {
        const { answers, answerPercentagesQuestions, isLoading, showNextButton } = this.state
        const { classes, prelander, theme, layout } = this.props

        const questionValues = this.state.questionValues
        const questionPage = this.state.questionPages[this.state.questionPageIndex]
        const completeStep = this.state.completeAnimationStep
        const headerImagePositionInCard = !(layout === 'exclusive' || layout === 'premium-exclusive')

        return (
            <Box className={'prelander-wrapper'}>
                {headerImagePositionInCard && theme?.headerImage && <HeaderImage theme={theme} questionPage={questionPage} />}
                {!showAnswerPercentages && answers && answers.length > 0 && (
                    <Box className={classes.prelanderAnswerWrapper + ' prelanderAnswerWrapper'}>
                        {answers.map((answer, index) => (
                            <Box className={classes.prelanderAnswer} key={index}>
                                {answer}
                            </Box>
                        ))}
                    </Box>
                )}
                {!this.state.showComplete && questionPage && (
                    <>
                        {questionPage.showHeader && <QuestionPageHeader questionPage={questionPage} layout={layout} />}
                        <Box mt={{ xs: -1, sm: -2 }} display={'flex'}></Box>
                        {showAnswerPercentages && (
                            <Box mb={1} pt={{ xs: 1, md: 1 }}>
                                {answerPercentagesQuestions?.map(answerPercentagesQuestion => (
                                    <>
                                        {answerPercentagesQuestion && answerPercentagesQuestion.options?.length > 0 && (
                                            <Box
                                                className={
                                                    classes.prelanderAnswerWrapper +
                                                    ' ' +
                                                    classes.prelanderAnswerBottomWrapper +
                                                    ' prelanderAnswerWrapper'
                                                }
                                                key={answerPercentagesQuestion.id}
                                            >
                                                <Typography variant="h6" className={classes.prelanderPercentageQuestion}>
                                                    {answerPercentagesQuestion.title}
                                                </Typography>
                                                <Box className={classes.prelanderPercentageAnswersWrapper}>
                                                        {answerPercentagesQuestion.options.map((option, index) => (
                                                            <Box
                                                                key={index}
                                                                className={
                                                                    classes.prelanderPercentageAnswerWrapper +
                                                                    ' ' +
                                                                    (option.checked ? classes.prelanderPercentageAnswerWrapperChecked : '')
                                                                }
                                                            >
                                                                {option.checked && <Box className={classes.prelanderPercentageAnswerCheckedBackground} />}
                                                                <Box
                                                                    className={
                                                                        classes.prelanderPercentageBar +
                                                                        ' ' +
                                                                        (option.checked ? classes.prelanderPercentageBarChecked : '')
                                                                    }
                                                                    style={{
                                                                        width: option.setWidth ? (option.answerPercentage / 60) * 95 + 5 + '%' : '5%'
                                                                    }}
                                                                />
                                                                <Box
                                                                    className={
                                                                        classes.prelanderPercentageLabel +
                                                                        ' ' +
                                                                        (option.checked ? classes.prelanderPercentageLabelChecked : '')
                                                                    }
                                                                >
                                                                    <span style={{
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        flex: 1
                                                                    }}>
                                                                        {option.label}
                                                                    </span>
                                                                    {option.checked && (
                                                                        <span className={classes.yourAnswerBadge}>
                                                                            Sinä
                                                                        </span>
                                                                    )}
                                                                </Box>
                                                                <Box
                                                                    className={
                                                                        classes.prelanderPercentageValue +
                                                                        ' ' +
                                                                        (option.checked ? classes.prelanderPercentageValueChecked : '')
                                                                    }
                                                                >
                                                                    {option.answerPercentage} %
                                                                </Box>
                                                            </Box>
                                                        ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </>
                                ))}
                            </Box>
                        )}
                        <Grid
                            container
                            spacing={2}
                            classes={{ item: classes.questionContainer }}
                            className={classes.questionWrapper}
                            item={true}
                            id="prelander-questions"
                        >
                            {!showNextButton &&
                                questionPage.elements.map((element, key) => {
                                    const questionValue = questionValues.find(x => x.id === element.id)
                                    const value = questionValue ? questionValue.value : null

                                    const questionElement = element
                                    questionElement.id = questionElement.title

                                    // Calculate question progress for the badge
                                    // Total = prelander questions + 1 if there's an initial answer from email (iav)
                                    const totalQuestions = this.state.questionPages.length + (hasInitialAnswer ? 1 : 0)
                                    // Current = current page index + 1 (1-based) + 1 if initial answer exists (it counts as Q1)
                                    const currentQuestion = this.state.questionPageIndex + 1 + (hasInitialAnswer ? 1 : 0)

                                    return (
                                        <React.Fragment key={key}>
                                            {element.elementType === 'question' && (
                                                <Question
                                                    question={questionElement}
                                                    value={value}
                                                    className={classes.prelanderQuestion}
                                                    onValueChanged={this.onQuestionValueChanged}
                                                    questionProgress={{ current: currentQuestion, total: totalQuestions }}
                                                    layout={layout}
                                                />
                                            )}
                                            {element.elementType === 'attentionElement' && <AttentionElement element={element} />}
                                        </React.Fragment>
                                    )
                                })}
                            {showNextButton && (
                                <Box className={classes.nextButtonWrapper} id="next-button">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        onClick={() => {
                                            this.showComplete()
                                            window.scrollTo({ top: 0, behavior: 'smooth' })
                                        }}
                                        disabled={isLoading}
                                    >
                                        Jatka
                                        <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'long-arrow-alt-right']} />
                                    </Button>
                                </Box>
                            )}
                            {questionPage.stepper && questionPage.stepper.place === 'footer' && (
                                <Grid item xs={12} sm={12} key={'stepper'} style={{ marginTop: 32, marginBottom: -16 }}>
                                    <QuestionPageStepper stepper={questionPage.stepper} />
                                </Grid>
                            )}
                            {questionPage.image && (
                                <div className={classes.imageWrapper}>
                                    <img src={questionPage.image} className={classes.image} />
                                </div>
                            )}
                        </Grid>
                        <Box py={1.5} style={{ flexGrow: 1 }}></Box>
                        {questionPage.footerText && (
                            <div className={'question-page-footer-text-wrapper ' + classes.questionPageFooterTextWrapper}>
                                <Typography component="div" variant="body1" align="center" color="textSecondary" id={'question-page-footer-text'}>
                                    {parse(questionPage.footerText)}
                                </Typography>
                            </div>
                        )}
                        {questionPage.showFooter && <QuestionPageFooter />}
                        {questionPage && questionPage.termsPosition === 'footer' ? (
                            <Terms domain={questionPage.domain} theme={theme} layout={layout} />
                        ) : (
                            <Box mt={{ xs: 1, sm: 3 }} />
                        )}
                    </>
                )}
                {this.state.showComplete && (
                    <>
                        {prelander.completeAnimation === 'research' ? (
                            <PrelanderCompleteModern
                                prelander={prelander}
                                questionPage={this.props.prelander.questionPages[0]}
                                theme={theme}
                                layout={layout}
                            />
                        ) : (
                            <PrelanderComplete
                                step={completeStep}
                                prelander={prelander}
                                animationLenght={completeAnimationStepLenghts[completeStep]}
                                questionPage={this.props.prelander.questionPages[0]}
                                theme={theme}
                                layout={layout}
                            />
                        )}
                    </>
                )}
            </Box>
        )
    }
}

export default withStyles(styles)(Prelander)
